module.exports = __webpack_public_path__ + "img/t8.a67d2d8e.jpg";